import { render, staticRenderFns } from "./TrainingGroup.vue?vue&type=template&id=975eee9e"
import script from "./TrainingGroup.vue?vue&type=script&lang=js"
export * from "./TrainingGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports